import request from '@/utils/request'
const apiPath = '/cust/userArchives'
import { downloadBlob } from '@/utils/download'
const userArchivesApi = {
  /**
   * 新增【用户档案列表】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【用户档案列表】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【用户档案列表】
   */
  fetchList(query) {
    return request.get(apiPath + '/list', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【用户档案列表】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
}
export default userArchivesApi

